import { usePostPortfolioBankProductMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBankProductMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { BANK_PRODUCT_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormDefaults";
import { getBankProductFormSchema } from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateBankProductForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioBankProductMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getBankProductFormSchema(t),
		defaultValues: BANK_PRODUCT_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddBankProductSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
